import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';

type PublicPortfolioHeadlineProfileStrenghProps = {
  value: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioHeadlineProfileStrengh',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  value: number;
};


const isProfileFull = computed(() => props.value === 100);
const rootClass = computed(() => ({
  'public-portfolio-headline-profile-strengh': true,
  'public-portfolio-headline-profile-strengh--full': isProfileFull.value,
}));
const iconName = computed(() => (isProfileFull.value ? 'check' : 'pause'));

return { __sfc: true,props, isProfileFull, rootClass, iconName }
}

})